module.exports = __webpack_public_path__ + "img/image.d0496096.png";